/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1TransferEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_TRANSFER_EVENT_ENTITY_NAME = 'ixc.funding.v1.TransferEvent';
export const ixcFundingV1TransferEventEntity = new schema.Entity<IxcFundingV1TransferEvent>(IXC_FUNDING_V1_TRANSFER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcFundingV1TransferEvent) => `${entity.metadata?.eventId}` });

